
































































































































































































































































































import BasicTs from "@/components/mixins/basicts.vue";
import moment from "moment-timezone";
import { Component, Vue, Mixins } from "vue-property-decorator";
import * as types from "@/lib/definition/types";
import {
  BotInfo,
  BrowserInfo,
  detect,
  NodeInfo,
  SearchBotDeviceInfo,
} from "detect-browser";
moment.locale("ja");
import { Octokit } from "@octokit/core";
import { Endpoints } from "@octokit/types";

@Component({
  mixins: [BasicTs],
})
export default class Projects extends Mixins(BasicTs) {
  private clients = new Array<types.ClientParam>();
  private activeClients = new Array<types.ClientParam>();
  private branches = new Array<types.BranchParam>();
  private projects = new Array<types.ProjectParamWithLocalDate>();
  private addingObj: types.ProjectParamWithLocalDate =
    this.$store.direct.getters.Project.emptyProject;
  private githubOrgs: Endpoints["GET /users/{username}/orgs"]["response"]["data"] =
    [];
  private selectedGithubOrg: string | null = null;
  private githubRepos: any[] = [];
  private selectedGithubRepo: string | null = null;
  private addingObjRepositories: types.ProjectParamWithLocalDate[] = [];
  private dialogAdding = false;
  private objectToDelete: types.ProjectParamWithLocalDate =
    this.$store.direct.getters.Project.emptyProject;
  private dialogDeleting = false;
  private requestParam: any = null;
  private newWorkOrderName = '';
  private workOrderLoading = false;
  private bulkAssignFiscalYear: number = new Date().getMonth() < 3 ? new Date().getFullYear() - 1 : new Date().getFullYear();
  private bulkAssignWorkOrderId: string = '';
  private bulkAssignPreview: any = null;
  private bulkAssignLoading = false;
  private browser:any = detect();
  private dateStyle = "";
  private timeStyle = "";
  async mounted() {
    this.browser = detect();
    if (this.browser !== null) {
      if (
        (this.browser?.os?.includes("iOS") ?? false) ||
        (this.browser?.os?.includes("Android") ?? false)
      ) {
        this.dateStyle = "input";
        this.timeStyle = "time";
      }
    }
  }

  async masterReady() {
    if (!this.$store.getters["Login/isAdmin"]) {
      // redirect to home when you are not admin
      this.$router.push(this.site.deployFolder + "/");
    }
    try {
      await this.$store.direct.dispatch.Project.getGithubUser();
      this.githubOrgs =
        (await this.$store.direct.dispatch.Project.getGithubOrgs()) ?? [];
      if (this.githubOrgs != null && this.githubOrgs.length > 0) {
        this.selectedGithubOrg = this.githubOrgs[0].login;
        await this.updateRepositories(this.selectedGithubOrg);
      }
    } catch (e) {
      this.dispSuccess(
        "Github連携に失敗しました。ユーザーページから連携してください"
      );
    }
    await this.search();
  }
  async updateRepositories(login: string) {
    const githubUsername = this.$store.direct.state.Project.githubusername;
    if (login === githubUsername) {
      this.githubRepos =
        (await this.$store.direct.dispatch.Project.getGithubUserRepositories()) ?? [];
    } else {
      this.githubRepos =
        (await this.$store.direct.dispatch.Project.getGithubOrgRepositories(
          login
        )) ?? [];
    }
  }
  async addRepo() {
    this.githubRepos.forEach((obj) => {
      if (obj.full_name == this.selectedGithubRepo) {
        this.addingObj.projectRepositories.push({
          projectRepositoryId: null,
          projectId: this.addingObj.projectId,
          organzationName: obj.owner.login,
          repositoryName: obj.name,
          organizationId: obj.owner.id,
          repositoryId: obj.id,
          url: obj.url,
        });
      }
    });
  }
  async deleteRepo(item: types.ProjectRepositoryParam) {
    this.addingObj.projectRepositories =
      this.addingObj.projectRepositories.filter((obj) => {
        return obj != item;
      });
  }
  async search() {
    this.clients = await this.$store.direct.dispatch.Project.listAllClients();
    this.branches = await this.$store.direct.dispatch.Project.listAllBranches();
    this.projects = await this.$store.direct.dispatch.Project.listAll();
  }
  getActiveClient(): Array<types.ClientParam> {
    return this.clients.filter((obj) => {
      return obj.isActive || obj.clientId == this.addingObj.clientId;
    });
  }
  async prepareToAdd() {
    this.addingObj = await this.$store.direct.dispatch.Project.defaultProject();
    this.activeClients = this.getActiveClient();
    this.dialogAdding = true;
  }
  get fiscalYearOptions(): number[] {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 5 }, (_, i) => currentYear - i);
  }
  get workOrderSelectItems(): { text: string; value: string }[] {
    if (!this.addingObj.workOrderNumbers) return [];
    return this.addingObj.workOrderNumbers.map(wo => ({
      text: `#${wo.serialNumber}${wo.name ? ' ' + wo.name : ''}`,
      value: wo.workOrderNumberId!
    }));
  }
  prepareToEdit(item: types.ProjectParamWithLocalDate) {
    this.addingObj = JSON.parse(JSON.stringify(item));
    this.activeClients = this.getActiveClient();
    this.bulkAssignWorkOrderId = '';
    this.bulkAssignPreview = null;
    this.dialogAdding = true;
  }
  async confirmAdding() {
    this.dialogAdding = false;
    this.requestParam = this.addingObj;
    this.requestParam.isPersonal = false;
    await this.$store.direct.dispatch.Project.add(this.requestParam);
    this.dispSuccess("クライアントを追加しました。");
    this.search();
  }
  formatWorkOrderNumbers(item: types.ProjectParamWithLocalDate): string {
    if (!item.workOrderNumbers || item.workOrderNumbers.length === 0) return '';
    return item.workOrderNumbers
      .map(wo => `#${wo.serialNumber}${wo.name ? ' ' + wo.name : ''}`)
      .join(', ');
  }
  async addWorkOrderNumber() {
    if (!this.addingObj.projectId) return;
    this.workOrderLoading = true;
    try {
      await this.$store.direct.dispatch.Project.addWorkOrderNumber({
        projectId: this.addingObj.projectId,
        name: this.newWorkOrderName
      });
      this.newWorkOrderName = '';
      await this.refreshWorkOrderNumbers();
      this.dispSuccess("作番を追加しました。");
    } catch (e) {
      this.dispError("作番の追加に失敗しました。");
    }
    this.workOrderLoading = false;
  }
  async updateWorkOrderName(wo: types.WorkOrderNumberParam) {
    if (!wo.workOrderNumberId) return;
    try {
      await this.$store.direct.dispatch.Project.updateWorkOrderNumber({
        workOrderNumberId: wo.workOrderNumberId,
        name: wo.name
      });
      this.dispSuccess("作番名を更新しました。");
    } catch (e) {
      this.dispError("作番名の更新に失敗しました。");
    }
  }
  async deleteWorkOrder(wo: types.WorkOrderNumberParam) {
    if (!wo.workOrderNumberId) return;
    if (this.addingObj.defaultWorkOrderNumberId === wo.workOrderNumberId) {
      this.dispError("デフォルト作番は削除できません。先にデフォルトを変更してください。");
      return;
    }
    this.workOrderLoading = true;
    try {
      await this.$store.direct.dispatch.Project.deleteWorkOrderNumber(wo.workOrderNumberId);
      await this.refreshWorkOrderNumbers();
      this.dispSuccess("作番を削除しました。");
    } catch (e) {
      this.dispError("作番の削除に失敗しました。");
    }
    this.workOrderLoading = false;
  }
  async setDefaultWorkOrder(workOrderNumberId: string) {
    try {
      await this.$store.direct.dispatch.Project.setDefaultWorkOrderNumber({
        project: this.addingObj,
        workOrderNumberId: workOrderNumberId
      });
      this.addingObj.defaultWorkOrderNumberId = workOrderNumberId;
      this.dispSuccess("デフォルト作番を設定しました。");
    } catch (e) {
      this.dispError("デフォルト作番の設定に失敗しました。");
    }
  }
  async refreshWorkOrderNumbers() {
    const updatedProjects = await this.$store.direct.dispatch.Project.listAll();
    const updated = updatedProjects.find(p => p.projectId === this.addingObj.projectId);
    if (updated) {
      this.addingObj.workOrderNumbers = updated.workOrderNumbers;
      this.addingObj.workOrderNumbersJSON = updated.workOrderNumbersJSON;
      this.addingObj.defaultWorkOrderNumberId = updated.defaultWorkOrderNumberId;
    }
    this.projects = updatedProjects;
  }
  async previewBulkAssign() {
    if (!this.addingObj.projectId || !this.bulkAssignWorkOrderId) return;
    this.bulkAssignLoading = true;
    try {
      this.bulkAssignPreview = await this.$store.direct.dispatch.Project.previewBulkAssignWorkOrder({
        projectId: this.addingObj.projectId,
        fiscalYear: this.bulkAssignFiscalYear,
        workOrderNumberId: this.bulkAssignWorkOrderId
      });
    } catch (e) {
      this.dispError("プレビューに失敗しました。");
    }
    this.bulkAssignLoading = false;
  }
  async executeBulkAssign() {
    if (!this.addingObj.projectId || !this.bulkAssignWorkOrderId) return;
    this.bulkAssignLoading = true;
    try {
      const result = await this.$store.direct.dispatch.Project.bulkAssignWorkOrder({
        projectId: this.addingObj.projectId,
        fiscalYear: this.bulkAssignFiscalYear,
        workOrderNumberId: this.bulkAssignWorkOrderId
      });
      this.dispSuccess(`${result.updatedProjectCount}件のプロジェクト、${result.updatedIssueCount}件のイシューに作番を適用しました。`);
      this.bulkAssignPreview = null;
    } catch (e) {
      this.dispError("一括適用に失敗しました。");
    }
    this.bulkAssignLoading = false;
  }
  async checkDateAndTime(object: types.ProjectParamWithLocalDate) {
    var startDate =
      object.startDateLocal == null || object.startDateLocal == ""
        ? null
        : moment(object.startDateLocal);
    var endedDate =
      object.endDateLocal == null || object.endDateLocal == ""
        ? null
        : moment(object.endDateLocal);
  }
}
